'use strict';

export default function($stateProvider, publicDocConfig) {
  'ngInject';
  $stateProvider
    .state('publicDocumentation', {
      abstract: true,
      template: '<publicdocumentation></publicdocumentation>'
    });

    publicDocConfig.publicDocumentation.forEach(article => {
      $stateProvider.state(`publicDocumentation.${article.name}`, {
        url: `/${article.name}`,
        template: require(`../static/${article.filename}`)
      });
    });
}


// WEBPACK FOOTER //
// ./client/app/documentation/public/publicDocumentation.routes.js